var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUpland = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 172,
    viewBox: "0 0 191 172",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0E4D2",
    fillRule: "evenodd",
    d: "M157.672 36.38C143.179.277 63.647-26.207 31.63 48.82-.385 123.85 24.918 83.033 3.474 128.093c-21.444 45.061 70.11 57.868 146.721 26.533 76.612-31.334 21.97-82.144 7.477-118.246z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpland, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upland.6b0e0ee6.svg";
export { ForwardRef as ReactComponent };